export const getInviteModalMessage = (usersSelected: number) => {
  let message = (
    <div>
      <p>You are about to send email invites to {usersSelected} users.</p>
      <p>
        This action will change their status to &apos;invited&apos; and Vault
        will immediately send these users email invites to the Vault mobile app.
      </p>
      <p>Do you wish to continue?</p>
    </div>
  );

  const emailsPerMinuteLimit = 5;

  if (usersSelected === 1) {
    message = (
      <div>
        <p>
          You are about to send an email invite to one user. This email will be
          sent immediately.
        </p>
        <p>Do you wish to continue?</p>
      </div>
    );
  } else if (usersSelected > emailsPerMinuteLimit) {
    const hours = Math.ceil(usersSelected / (emailsPerMinuteLimit * 60));

    if (hours === 1) {
      message = (
        <div>
          <p>You are about to send email invites to {usersSelected} users.</p>
          <p>These emails will take approximately one hour to send.</p>
          <p>Do you wish to continue?</p>
        </div>
      );
    } else {
      message = (
        <div>
          <p>You are about to send email invites to {usersSelected} users.</p>
          <p>These emails will take approximately {hours} hours to send.</p>
          <p>Do you wish to continue?</p>
        </div>
      );
    }
  }

  return message;
};
